import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2d5872eb"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "article_detail" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "article_header_bg" }, null, -1))
const _hoisted_3 = { class: "content_box" }
const _hoisted_4 = { class: "list_container" }
const _hoisted_5 = { class: "px-3 breadcrumb_list" }
const _hoisted_6 = { class: "article_box" }
const _hoisted_7 = { class: "article_tit" }
const _hoisted_8 = { class: "article_date" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line_content" }, null, -1))
const _hoisted_10 = { class: "article_con" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"line-height":"2em"} }, [
  /*#__PURE__*/_createElementVNode("br")
], -1))
const _hoisted_12 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_breadcrumb_item = _resolveComponent("a-breadcrumb-item")!
  const _component_a_breadcrumb = _resolveComponent("a-breadcrumb")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_a_breadcrumb, { separator: ">" }, {
            default: _withCtx(() => [
              _createVNode(_component_a_breadcrumb_item, null, {
                default: _withCtx(() => [
                  _createTextVNode("首页")
                ]),
                _: 1
              }),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.routerPath, (item, index) => {
                return (_openBlock(), _createBlock(_component_a_breadcrumb_item, { key: index }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(item), 1)
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.articleObj.article?.title), 1),
          _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.articleObj.article?.updateDate), 1),
          _hoisted_9,
          _createElementVNode("div", _hoisted_10, [
            _hoisted_11,
            _createElementVNode("p", {
              class: "article_text",
              innerHTML: _ctx.articleObj.article?.articleData?.content
            }, null, 8, _hoisted_12)
          ])
        ])
      ])
    ])
  ]))
}